import { motion } from 'framer-motion';

export default function Reveal({ children, delay = 0, y = 32, className, ...rest }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.15 }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
      {...rest}
    >
      {children}
    </motion.div>
  );
}

export function SectionHeader({ eyebrow, title, className }) {
  return (
    <div className={className}>
      <Reveal>
        <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-ultraviolet mb-4">
          {eyebrow}
        </p>
      </Reveal>
      <Reveal delay={0.08}>
        <h2 className="font-syne font-extrabold text-3xl sm:text-4xl lg:text-5xl text-white tracking-tight leading-[1.02]">
          {title}
        </h2>
      </Reveal>
      <Reveal delay={0.16}>
        <div className="mt-6 h-px w-full bg-gradient-to-r from-ultraviolet/60 via-magenta/30 to-transparent" />
      </Reveal>
    </div>
  );
}
